<div class="gl-page">
  <div class="gl-page__header">
    <h1 class="gl-page__title">Verwerkingsdefinitie</h1>

    <div class="gl-page__header-actions">
      <yds-button variant="primary" (click)="navigateToCreate()">
        Verwerkingsdefinitie toevoegen
      </yds-button>
    </div>
  </div>

  <div class="gl-page__filter">
    @if (isLoadingGroups()) {
      <div class="gl-list-state">
        <yds-spinner [label]="'Boekingsgroepen laden...'" />
      </div>
    } @else if (bookingGroups().length === 0) {
      <yds-empty-states [message]="'Er zijn nog geen boekingsgroepen'" />
    } @else {
      <yds-dropdown
        label="Boekingsgroep"
        [items]="bookingGroupOptions()"
        [allowClear]="false"
        [value]="bookingGroupId()"
        (valueChange)="onBookingGroupChange($event)"
      />
    }
  </div>

  @if (!isLoadingGroups() && bookingGroups().length > 0) {
    @if (isLoading()) {
      <yds-card>
        <div class="gl-list-state">
          <yds-spinner [label]="'Verwerkingsdefinities laden...'" />
        </div>
      </yds-card>
    } @else if (tableItems().length === 0) {
      <yds-empty-states [message]="'Er zijn nog geen verwerkingsdefinities'" />
    } @else {
      <yds-card>
        <div class="gl-list-table">
          <yds-table
            [embedded]="true"
            [showPaginationFooter]="journalProcessDefinitions().length > 0"
            [columns]="tableColumns"
            [items]="tableItems()"
            [zebra]="true"
            [dottedColumns]="true"
            [clickable]="true"
            (rowClick)="onTableRowClick($event)"
          >
            <ng-template ydsTableCell="actions" let-item="item">
              <yds-split-button
                label="Bekijk details"
                [items]="splitButtonItems"
                variant="default"
                size="sm"
                (mainClick)="viewItem(item.id, $event)"
                (itemClick)="handleActionClick(item.id, $event)"
              ></yds-split-button>
            </ng-template>

            @if (journalProcessDefinitions().length > 0) {
              <yds-pagination
                pagination
                [(pageIndex)]="pageIndex"
                [pageSize]="pageSize"
                [totalItems]="journalProcessDefinitions().length"
              />
            }
          </yds-table>
        </div>
      </yds-card>
    }
  }
</div>
